import ArrowForward from "@mui/icons-material/ArrowForward";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)({
    textDecoration: "none",
    "&:focus": {
        textDecoration: "none",
    },
});

const StyledListTitle = styled("h3")({
    margin: "8px 0",
    padding: 16,
});
const StyledArrowForward = styled(ArrowForward)({
    color: "#2C99D2",
    marginRight: "16px",
});

const KMTools = () => {
    return (
        <Paper style={{ marginBottom: "12px" }}>
            <List disablePadding component="nav">
                <ListItem divider disableGutters>
                    <StyledListTitle>KM Toolbox</StyledListTitle>
                    <Divider />
                </ListItem>

                <StyledLink to="/training-content">
                    <ListItem divider button disableGutters secondaryAction={<StyledArrowForward />}>
                        <ListItemText primary="Training Content" />
                    </ListItem>
                </StyledLink>

                <ListItem
                    divider
                    button
                    disableGutters
                    secondaryAction={<StyledArrowForward />}
                    onClick={() =>
                        window.open(
                            "https://s3.us-east-2.amazonaws.com/connect.kidder.com/downloads/KM+Connect+Q+%26+A.docx",
                            "_blank"
                        )
                    }
                >
                    <ListItemText primary="FAQ" />
                </ListItem>

                <ListItem
                    divider
                    button
                    disableGutters
                    secondaryAction={<StyledArrowForward />}
                    onClick={() => window.open("http://www.kiddermathews.com/research.php", "_blank")}
                >
                    <ListItemText primary="Research Reports" />
                </ListItem>

                <ListItem
                    divider
                    button
                    disableGutters
                    secondaryAction={<StyledArrowForward />}
                    onClick={() => window.open("https://app.powerbi.com/sharedwithme", "_blank")}
                >
                    <ListItemText primary="Power BI Reports" />
                </ListItem>

                <ListItem
                    divider
                    button
                    disableGutters
                    secondaryAction={<StyledArrowForward />}
                    onClick={() =>
                        window.open(
                            "https://s3.us-east-2.amazonaws.com/connect.kidder.com/downloads/KM+Connect+Helpful+Links.xlsx",
                            "_blank"
                        )
                    }
                >
                    <ListItemText primary="Helpful Links" />
                </ListItem>
            </List>
        </Paper>
    );
};

export default KMTools;
